import { Container, Stack, Typography, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Footer from "splash_components/Splash/CommonComponents/Footer";
import { NavigationBar } from "splash_components/Splash/CommonComponents/NavigationBar";

import React from "react";
import { tSplash } from "locales/splash/cruxTranslation";

export default function ContactSuccess() {
  const theme = useTheme();

  return (
    <div style={{ backgroundColor: "#F4F4F1", userSelect: "text" }}>
      {screen.width < theme.breakpoints.values.sm ? (
        // Mobile
        <Stack sx={{ minHeight: "100vh", maxHeight: "100vh" }}>
          <NavigationBar theme={theme} mobile />
          <Container
            style={{
              paddingLeft: theme.spacing(6),
              paddingRight: theme.spacing(6),
              paddingTop: theme.spacing(5),
            }}
          >
            <Stack
              direction="column"
              alignItems="center"
              justifyContent="center"
              spacing={2}
            >
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={4}
                sx={{ width: "100%" }}
              >
                <img src="https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/c38fb3dc-423c-4bca-3738-80440dce3c00/largeavatar" style={{ height: "75px" }} />
                <Typography variant="h4" sx={{ textAlign: "center" }}>
                  <b>
                    {tSplash("contact_success.title")}
                  </b>
                </Typography>
              </Stack>
              <Typography variant="subtitle1" sx={{ textAlign: "center" }}>
                {tSplash("contact_success.subtitle")}
              </Typography>
            </Stack>
          </Container>
          <Box sx={{ flexGrow: 1 }} />
          <Footer theme={theme} />
        </Stack>
      ) : (
        // Desktop
        <Stack sx={{ minHeight: "100vh", maxHeight: "100vh" }}>
          <Container
            style={{
              paddingLeft: theme.spacing(6),
              paddingRight: theme.spacing(6),
            }}
          >
            <NavigationBar theme={theme} mobile={false} />
            <Box pt={theme.spacing(12)} pb={theme.spacing(3)}>
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={4}
              >
                <Stack direction="row" justifyContent="center" alignItems="center">
                  <img src="https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/c38fb3dc-423c-4bca-3738-80440dce3c00/largeavatar" style={{ height: "100px" }} />
                </Stack>

                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Typography variant="h2" sx={{ textAlign: "center", fontWeight: 900, maxWidth: "800px" }}>
                    {tSplash("contact_success.title")}
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{ textAlign: "center", marginTop: theme.spacing(1), maxWidth: "80%", fontWeight: 400 }}
                  >
                    {tSplash("contact_success.subtitle")}
                  </Typography>
                </Stack>
              </Stack>
            </Box>
          </Container>
          <Box sx={{ flexGrow: 1 }} />
          <Footer theme={theme} />
        </Stack>
      )
      }
    </div >
  );
}
